var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 78 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66857 8H0V0H1.66857V8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3242 5.50857V0H13.9813V8H12.2785L8.25562 2.48V8H6.58705V0H8.28991L12.3242 5.50857Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2824 0H24.0081V1.47429H21.9738V8H20.3167V1.47429H18.2824V0Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2134 0V1.47429H29.9677V3.18857H32.7677V4.66286H29.9677V6.52571H33.2134V8H28.2991V0H33.2134Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3458 8H42.3229L40.0829 4.70857H39.5458V8H37.8772V0H41.1001C41.9229 0 42.5515 0.220952 42.9858 0.662857C43.4277 1.10476 43.6487 1.68381 43.6487 2.4C43.6487 3.56571 43.0696 4.2781 41.9115 4.53714L44.3458 8ZM39.5458 3.34857H40.8601C41.2258 3.34857 41.5039 3.27619 41.6944 3.13143C41.8925 2.97905 41.9915 2.73524 41.9915 2.4C41.9915 2.07238 41.8925 1.83619 41.6944 1.69143C41.5039 1.54667 41.2258 1.47429 40.8601 1.47429H39.5458V3.34857Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3979 5.50857V0H56.055V8H54.3521L50.3293 2.48V8H48.6607V0H50.3636L54.3979 5.50857Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8818 3.87429L67.6475 8H65.7275L63.9789 5.25714L62.2418 8H60.3332L63.0875 3.88571L60.4818 0H62.3789L63.9789 2.50286L65.5904 0H67.4989L64.8818 3.87429Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.307 0H77.0327V1.47429H74.9984V8H73.3412V1.47429H71.307V0Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7be808dbd1eb271f15fb8a5526611ed7.svg";
export { ForwardRef as ReactComponent };